<!--
 * @Author: Victor victorqwer1234567890@gmail.com
 * @Date: 2023-12-23 16:55:15
 * @LastEditors: Merlin
 * @LastEditTime: 2025-08-20 11:50:19
 * @FilePath: /gamefi/components/Providers/index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <ClientOnly>
        <ProvidersGlobal />
    </ClientOnly>
</template>

<script>
export default {
    name: 'providers',
}
</script>
